var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFashionAffordable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Shirt-Plain--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shirt Plain Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 7.79 19.8 4A5.45 5.45 0 0 0 16 2.5c-0.11 0 -0.43 -0.07 -0.5 0.3A3.69 3.69 0 0 1 12 6a3.69 3.69 0 0 1 -3.49 -3.2c-0.07 -0.37 -0.4 -0.27 -0.5 -0.3A5.45 5.45 0 0 0 4.2 4L0.29 7.79a1 1 0 0 0 0 1.42l2.33 2.32A1 1 0 0 0 4 11.6l1.24 -1a0.49 0.49 0 0 1 0.53 -0.05A0.5 0.5 0 0 1 6 11v9.5a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1V11a0.5 0.5 0 0 1 0.28 -0.45 0.49 0.49 0 0 1 0.53 0.05l1.23 0.95a1 1 0 0 0 1.34 -0.06l2.33 -2.32a1 1 0 0 0 0 -1.38Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFashionAffordable);
export default ForwardRef;